// extracted by mini-css-extract-plugin
export var htmlPreview = "_wg-0";